// extracted by mini-css-extract-plugin
export default {"form_body":"ConfirmTwoFaCodeFields_form_body__Q+sp6"};